import {
  TaxRateRecord,
  TaxApplication,
  TaxRateStatus,
} from '../../../../types/accounting';

export interface TaxRateFormState {
  code: string;
  name: string;
  rate: string;
  application: TaxApplication;
  status: TaxRateStatus;
  outputAccountId: string;
  inputAccountId: string;
  description: string;
}

export const TAX_APPLICATION_OPTIONS: {
  value: TaxApplication;
  label: string;
}[] = [
  { value: 'sales', label: 'Sales' },
  { value: 'purchase', label: 'Purchase' },
  { value: 'both', label: 'Both' },
];

export const TAX_STATUS_OPTIONS: { value: TaxRateStatus; label: string }[] = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

export const createEmptyTaxRateForm = (): TaxRateFormState => ({
  code: '',
  name: '',
  rate: '',
  application: 'sales',
  status: 'active',
  outputAccountId: '',
  inputAccountId: '',
  description: '',
});

export const createTaxRateFormFromRecord = (
  taxRate: TaxRateRecord,
): TaxRateFormState => ({
  code: taxRate.code,
  name: taxRate.name,
  rate: String(taxRate.rate),
  application: taxRate.application,
  status: taxRate.status,
  outputAccountId: taxRate.output_account_id ?? '',
  inputAccountId: taxRate.input_account_id ?? '',
  description: taxRate.description ?? '',
});
